import { Routes, Route, useOutletContext } from "react-router-dom";
import Home from "../Pages/Private/Planning/Home/Home";
import IndividualPlanning from "../Pages/Private/Planning/IndividualPlanning";
import ListIndividual from "../Pages/Private/Individual/ListIndividual";
import { IndividualProfile } from "../Pages/Private/Individual/IndividualProfile";
import InformationsIndividualTab from "../Pages/Private/Individual/Tabs/InformationsIndividuals";
import ValidationsList from "../Pages/Private/Planning/Validation/ValidationsList";
import ValidationGap from "../Pages/Private/Planning/Validation/ValidationGap";
import DailyFollowUp from "../Pages/Private/Planning/DailyFollowUp/DailyFollowUp";

export const PlanningRouter = () => {
    return (
        <Routes>
            {" "}
            <Route path="/dashboard" element={<Home />} />
            <Route
                path="/planning"
                element={<IndividualPlanning view="week" />}
            />
            <Route path="/validation" element={<ValidationsList defaultTab="demandes"/>} />
            <Route path="/daily_follow_up" element={<DailyFollowUp />} />
            <Route path="/validation_gap" element={<ValidationGap />} />
            <Route path="/team" element={<ListIndividual />} />
            <Route path="/team/:user_id" element={<IndividualProfile />} />
            <Route
                path="/team/form/create"
                element={<InformationsIndividualTab profile={null} />}
            />
        </Routes>
    );
};
